<template>
  <div class="content__wrapper">
    <Spinner :isOpen="isLoading" />
    <div class="map__wrapper">
      <WorldMap2D class="2d-world-map" />
      <!-- <TotalAttackCount class="total-attack" /> -->
      <!-- <Clock class="clock" /> -->
    </div>
    <!-- <Legend class="legend" /> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

import WorldMap2D from 'Components/NewSVGMap';
// import Legend from 'Components/Legend';
// import TotalAttackCount from 'Components/TotalAttackCount';
// import Clock from 'Components/Timer';
import Spinner from 'Components/LoadingSpinner';

export default {
  name: 'ContentContainer',
  components: {
    WorldMap2D,
    // Legend,
    // Clock,
    // TotalAttackCount,
    Spinner
  },
  computed: {
    ...mapState({ isLoading: 'eventStore/eventsLoading' })
  }
};
</script>

<style lang="scss" scoped>
@import 'Plugins/style/breakpoints';
.content__wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
// .content__wrapper {
//   position: relative;
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;

//   .spinner-backdrop {
//     position: absolute;
//     z-index: 10;
//     height: 100vh;
//     width: 100vw;
//     top: 0;
//     left: 0;
//     background: rgba(0, 0, 0, 0.35);
//   }

//   .map__wrapper {
//     position: relative;
//     width: 100%;
//     .clock,
//     .total-attack {
//       position: absolute;
//       bottom: 2em;
//       margin: 1em 0 0 0;
//       font-size: 0.75em;
//     }
//     .total-attack {
//       left: 1em;
//     }
//     .clock {
//       font-size: 0.5em;
//       right: 1em;
//       bottom: 2.5em;
//     }
//   }

//   @media (min-width: $phone) and (max-width: $tablet) {
//   }

//   @media (min-width: $tablet) and (max-width: $desktop) {
//     .map__wrapper {
//       .total-attack {
//         left: 2em;
//         font-size: 1.4em;
//       }
//       .clock {
//         right: 2.5em;
//         font-size: 1em;
//       }
//     }
//   }

//   @media (min-width: $desktop) {
//     position: relative;
//     .map__wrapper {
//       .total-attack {
//         left: 4em;
//         bottom: 4em;
//         font-size: 1.4em;
//       }
//       .clock {
//         right: 4em;
//         bottom: 4.5em;
//         font-size: 1.3em;
//       }
//     }
//     .legend {
//       position: absolute;
//       bottom: 4em;
//       left: 50%;
//       transform: translateX(-50%);
//     }
//   }
// }
</style>
